import * as types from "./type";

const initialState = {
  data: [],
  dataList: [],
  loading: false,
  editLoad: false,
};

export const creditReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CREDITS:
      return {
        ...state,
        ...{ loading: true },
      };

    case types.GET_CREDITS_SUCCESS:
      return {
        ...state,
        ...{
          dataList: action.payload,
          loading: false,
        },
      };

    case types.GET_CREDITS_FAIL: {
      return {
        ...state,
        ...{ dataList: [], loading: false },
      };
    }

    case types.UPDATE_CREDIT:
      return {
        ...state,
        ...{ loading: true },
      };

    case types.UPDATE_CREDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case types.UPDATE_CREDIT_FAIL:
      return {
        ...state,
        loading: false,
        data: action.payload.response.data,
      };
    case types.CREATE_CREDIT:
      return {
        ...state,
        ...{ loading: true },
      };

    case types.CREATE_CREDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case types.CREATE_CREDIT_FAIL:
      return {
        ...state,
        loading: false,
        data: action.payload.response.data,
      };
    case types.RESET_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
      };

    default:
      return state;
  }
};
